'use strict';
import {settings} from '../../variables.js'
var angularTemplateBase = settings.angularTemplatesBase

angular.
module('support')
.component('supportform', {
        templateUrl: angularTemplateBase+'support/support-form.template.html?1',
        controller: ['$routeParams', '$location', '$cookies', 'Support', function SupportFormCtrl($routeParams, $location, $cookies, Support) {
            this.$onInit = function (){
                var self = this;
                self.step = 'start';
                self.set_step = function(step){
                    self.step = step;
                }

                self.support = Support.get({});

                self.save_support = function(){
                    self.support.$save(
                        function(response){
                            self.step = 'complete';
                            self.disable_btn = false;
                        },
                        function(response){
                            self.errors = response.data;
                            self.disable_btn = false;
                        }
                    )
                }
            }
        }]
})
.component('supportlist', {
    templateUrl: angularTemplateBase+'support/support.template.html',
    controller: ['$routeParams', '$location', '$cookies', 'SupportList',
        function SupportListCtrl($routeParams, $location, $cookies, SupportList) {
        var self = this;
        self.support_list = SupportList.query({});
    }]
})
.component('supportcomments', {
    templateUrl: angularTemplateBase+'support/support-comments.template.html',
    bindings: {
        supportid: '@'
    },
    controller: ['$routeParams', '$location', '$cookies', 'SupportCommentsList',
        function SupportCommentsListCtrl($routeParams, $location, $cookies, SupportCommentsList) {
            this.$onInit = function () {
                var self = this;
                self.comments_list = SupportCommentsList.query({supportid: self.supportid});
            }

    }]
})
.component('supportcommentform', {
    templateUrl: angularTemplateBase+'support/support-comment-form.template.html',
    bindings: {
        supportid: '@'
    },
    controller: ['$routeParams', '$location', '$cookies', 'SupportComment',
        function SupportCommentFormCtrl($routeParams, $location, $cookies, SupportComment) {
            this.$onInit = function () {
                var self = this;

                self.step = 'form';

                self.support = SupportComment.get({supportid: self.supportid});

                self.save_support = function(){
                    self.support.$save(
                        function(response){
                            self.step = 'complete';
                            self.disable_btn = false;
                        },
                        function(response){
                            self.errors = response.data;
                            self.disable_btn = false;
                        }
                    )
                }

            }

    }]
})
;